// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorFulfillmentSets = (client) => ({
    /**
     * `POST /vendor/fulfillment-sets/:id/service-zones`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateServiceZone
     * @source packages/modules/b2c-core/src/api/vendor/fulfillment-sets/[id]/service-zones/route.ts
     */
    createServiceZone: (id, body, query, headers) => client.fetch(buildPath("/vendor/fulfillment-sets/:id/service-zones", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/fulfillment-sets/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteFulfillmentSet
     * @source packages/modules/b2c-core/src/api/vendor/fulfillment-sets/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/fulfillment-sets/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/fulfillment-sets/:id/service-zones/:zone_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteServiceZoneById
     * @source packages/modules/b2c-core/src/api/vendor/fulfillment-sets/[id]/service-zones/[zone_id]/route.ts
     */
    deleteServiceZone: (id, zoneId, body, query, headers) => client.fetch(buildPath("/vendor/fulfillment-sets/:id/service-zones/:zone_id", [id, zoneId]), { method: "DELETE", body, query, headers }),
    /**
     * `POST /vendor/fulfillment-sets/:id/service-zones/:zone_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateServiceZoneById
     * @source packages/modules/b2c-core/src/api/vendor/fulfillment-sets/[id]/service-zones/[zone_id]/route.ts
     */
    updateServiceZone: (id, zoneId, body, query, headers) => client.fetch(buildPath("/vendor/fulfillment-sets/:id/service-zones/:zone_id", [id, zoneId]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=fulfillment-sets.js.map